<div class="flex-col">
  <!--  products name and filter  -->
  <section class="flex w-full">
      <div class="mb-[40px] w-full flex justify-start text-cafe text-xl sm:text-3xl font-medium font-['Roboto']">
        {{'components.SpecialProductsSearchResultComponent.title'| transloco}}
      </div>
  </section>
  <!--  all products  -->
  @if(products() !== null) {
    @if(products()!.length > 0) {
      <section>
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6
        gap-x-0 gap-y-8 md:gap-x-0 md:gap-y-0 lg:gap-y-2 lg:gap-x-2 xl:gap-y-6 xl:gap-x-2
        place-items-start justify-items-center">
          @for(product of products(); track product.productoId) {
            <ln-main-product-card [product]="product"></ln-main-product-card>
          }
        </div>
      </section>
    } @else {
      <ln-empty-search-card></ln-empty-search-card>
    }
  }

</div>


